import { render, staticRenderFns } from "./contentElementProductPlacement.vue?vue&type=template&id=218d8f2e&scoped=true"
import script from "./contentElementProductPlacement.vue?vue&type=script&lang=js"
export * from "./contentElementProductPlacement.vue?vue&type=script&lang=js"
import style0 from "./contentElementProductPlacement.vue?vue&type=style&index=0&id=218d8f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d8f2e",
  null
  
)

export default component.exports